<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"
			getUrl="web/equipment/check/standard/group/equipment/page" getKey="rows" :columns="columns">
			<!-- 搜索框插槽 -->
			<template #top>
				<el-descriptions>
					<el-descriptions-item :label="$t('dianjianfenzu')">
						{{$attrs.group.group}}
					</el-descriptions-item>
				</el-descriptions>
			</template>
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('shebeimingcheng')">
						<el-input v-model="yt.conditions.equipmentName"></el-input>
					</el-form-item>
					<el-form-item :label="$t('shebeiSN')">
						<el-input v-model="yt.conditions.equipmentSn"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear(yt.conditions = {
					groupId: $attrs.group.id
				})">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1');" type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/equipment/check/standard/group/equipment/delete')">
							{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('shebeimingcheng')" required>
						<yi_cross_select :component="'web_base_equipment_list'" :max="200" multiple
							:ids.sync="yt.editObj.equipmentIds"></yi_cross_select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="yt.editObj.loading" size="mini"
						@click="beforeAdd(yt.editObj);yt.req('POST','/web/equipment/check/standard/group/equipment/create')"
						type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'web_base_maintain_standard_group_equipment',
		created() {
			setTimeout(() => {
				this.yt.conditions = {
					groupId: this.$attrs.group.id,
				}
				this.yt.get(1);
			}, 300)
		},
		data() {
			return {
				options: [{
					label: this.$t('nian'),
					value: 1
				}, {
					label: this.$t('yue'),
					value: 2
				}, {
					label: this.$t('zhou'),
					value: 3
				}, {
					label: this.$t('tian'),
					value: 4
				}],
				list: [],
				organizationList: [],
				customerList: [],
				shiftList: [],
				maintainTypeList: [],
				columns: [{
					label: 'shebeimingcheng',
					prop: 'equipmentName',
					width: 130
				}, {
					label: 'shebeiSN',
					prop: 'equipmentSn',
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 160,
					fixed: 'right'
				}],
			}
		},

		methods: {
			beforeAdd(editObj) {
				editObj.groupId = this.$attrs.group.id
			},
			// 重置
			clear() {
				this.yt.conditions = {
					pageSize: 10
				}
				this.yt.get(1)
			},
		},
		watch: {

		}
	};
</script>
